<template>
  <div :class="(asvale == true?'boxxs1':'boxx')">
    <!-- <div class="sousuo" style="display: flex;justify-content: center;"> -->
    <!-- <div> -->
    <!-- <input type="text" @input="xainshi(params.learn_name)" v-model="params.learn_name" placeholder="请输入关键词" class="sousuo-imput">
        <img @click="search" style="cursor:pointer;" src="../../../static/img2/sous.png" alt="">
        <i @click="empty" v-show="xiaochu" class="el-icon-close"></i>
        <button @click="search" style="cursor:pointer;">搜索</button> -->
    <!-- </div> -->
    <!-- <el-switch class="kiaguanbis" @change="genghuanzhut" v-model="asvale" active-color="rgb(5, 34, 39)" inactive-color="#212129">
      </el-switch> -->
    <!-- </div> -->
    <div class="box-top">
      <div class="box-top-inp">
        <div class="demo-ruleForm-div">
          <input v-model="params.learn_name" @change="xainshi(params.learn_name)" placeholder="请输入关键词" class="demo-ruleForm-input" />
          <button type="button" name="button" class="loginBtn" @click="search()">
            <img @click="search" style="cursor:pointer;" src="../../../static/img2/sous.png" alt="">&nbsp;搜 索
          </button>
        </div>
      </div>
    </div>
    <div :class="(asvale == true?'optionss1a':'options')">
      <div class="type">
        <div class="direction1"><span>训练方向：</span><span @click="ofHidden" :class="completeclor(1)" style="cursor:pointer; padding: 0 10px 0 10px;">全部</span></div>
        <div class="directionitem" v-for="(item, index) in categoryList" :key="index"><span style="cursor:pointer;" :class="color(index)" @click="handelCategoryList(item, index)">{{ item.label }}{{ item.count == 0 ? '' :
                '(' + item.count + ')'
            }}</span></div>
      </div>
      <div class="typebox">
        <div class="direction2"><span>训练类型：</span><span @click="complete" :class="completeclor1(3)" style="cursor:pointer; padding: 0 10px 0 10px;">全部</span></div>
        <div class="directionitem1">
          <span v-show="com_plete" v-for="(item, index) in categoryTwoList" :key="index" @click="training_type(item, index)" :class="color2(index)" style="cursor:pointer;">{{ item.label }}({{
                item.count
            }})</span>
        </div>
        <div class="xianads" style="width:100%;height:2px;position: absolute;top: 65px;left: 0;"></div>
      </div>
    </div>
    <div class="curelist" style="cursor:pointer;" v-loading="show" element-loading-text="拼命加载中." element-loading-spinner="el-icon-loading" element-loading-background="rgba(25, 26, 31, 0.8)">
      <div class="imglist" v-for="(practice, id) in practiceList" :key="id" @click="courseHandler(practice.id, practice)">
        <img :src="imgurl + practice.thum" style="width:100%" alt="">
        <span class="sp1">{{ practice.name }}</span>
        <span class="sp2"><img src="../../../static/img2/time.png" alt=""></span>
        <span class="sp3">{{ practice.change_time }} </span>
        <span class="sp4"><img src="../../../static/img2/rs.png" alt=""></span>
        <span class="sp5">{{ computeCount(practice.user_count) }}</span>
        <span class="sp6"><img src="../../../static/img2/xx.png" alt=""><img src="../../../static/img2/xx.png" alt=""><img src="../../../static/img2/xx.png" alt=""><img src="../../../static/img2/xx.png" alt=""><img src="../../../static/img2/xx.png" alt=""></span>
        <div class="botomsp"></div>
      </div>
    </div>
    <div class="bottomtion" v-show="Hidethe_paging">
      <el-pagination background @current-change="pageCurrentChange" :pager-count="pageform.countPage" :page-count="pageform.pages" :current-page="pageform.pageNum" layout="prev, pager, next" :total="pageform.total" :page-size='8'>
      </el-pagination>
    </div>

  </div>
</template>

<script>
export default {
  inject: ['reload'],
  name: 'PracticeList',
  data() {
    return {
      // 分页插件
      asvale: false,
      pageform: {
        total: null,
        pages: null, // 总页数
        pageNum: 1, // 当前的页码
        pageSize: 8, // 每页显示条目个数
        countPage: 11, // 分页个数
      },
      params: {
        class_id: this.$store.state.userInfo.class_id,
        user_id: this.$store.state.userInfo.id,
        page_size: 8,
        page: 1,
        category_id: '',
        type: 'learn',
      },
      params4: {
        type: 'learn',
        user_id: this.$store.state.userInfo.id,
      },
      categoryList: [],
      categoryTwoList: [],
      index: '',
      count: '',
      count1: '',
      imgurl: 'http://www.univrlab.com/',
      count2: 1,
      show: true,
      count3: '',
      xiaochu: false,
      Hidethe_paging: true,
      com_plete: true,
      value: '',
      practiceList: [],
      loading: true,
      status: 0,
    }
  },

  methods: {
    genghuanzhut() {
      console.log(1111)
    },
    computeCount(value) {
      //console.log(value);
      if (!value) return 0
      //  console.log(value.length)
      return value >= 10000 ? `${String(value).substring(0, 1)}万+` : value
    },
    getTestStatus() {
      this.$http.getTestStatus().then((res) => {
        this.status = res.data
        // console.log(res.data)
      })
    },
    /* 分页插件 */
    // pageNum (当前页数)改变时会触发
    pageCurrentChange(val, e, form, jobExpLabel, pageform, searchVal) {
      // console.log('当前页:'+ val);
      this.pageform.pageNum = val
      this.params.page = val
      this.getCourseList()
    },
    search() {
      this.params.page = 1
      this.pageform.pageNum = 1
      if (this.params.category_id != undefined) {
        this.params.category_id = ''
      }
      this.getCourseList()
    },
    empty() {
      this.params.learn_name = ''
      this.xiaochu = false
    },
    xainshi(val) {
      if (val) {
        this.xiaochu = true
      } else {
        this.xiaochu = false
      }
    },
    // 获取分类列表
    getCategoryList() {
      this.$http
        .categoryTree(this.params4)
        .then((res) => {
          this.categoryList = res.data
          console.log(this.categoryList)
          this.categoryList.forEach((element) => {
            console.log(element.count)
            if (element.count == '0') {
              element.label = ''
            }
          })
        })
        .catch((err) => {
          // console.log(err);
        })
    },
    courseHandler(courseId, practice) {
      console.log(practice.childrens.length)
      if (practice.childrens.length == 0) {
        this.$router.push({
          path: `/courses/${courseId}/details-introduce`,
        })
      } else {
        this.$router.push({
          name: 'Channel',
          query: {
            courseId: courseId,
            childrens: practice.childrens,
            practice: practice,
          },
        })
      }
    },

    handelCategoryList(item, index) {
      this.params.category_id = item.value
      console.log(this.params.category_id)
      if (this.params.learn_name != undefined) {
        this.params.learn_name = ''
      }
      let arr = this.categoryList.find((v) => v.value === item.value)
      this.categoryTwoList = arr.children
      // let index = index
      //  console.log( this.categoryTwoList);
      this.count = index
      this.count2 = 2
      this.count1 = ''
      this.count3 = 3
      this.params.page = 1
      this.pageform.pageNum = 1
      this.getCourseList()
    },
    complete() {
      this.count3 = 3
      this.count1 = ''
      //  console.log(this.count)
      this.practiceList = []
      this.pageform.pageNum = 1
      this.show = true
      //  console.log( this.params.category_id)
      if (this.count == 0) {
        this.params.category_id = 2
      } else {
        this.params.category_id = 17
      }
      this.params = {
        page_size: 8,
        page: 1,
        category_id: this.params.category_id,
      }
      this.getCourseList()
    },
    ofHidden() {
      this.count2 = 1
      this.count = ''
      this.count3 = ''
      this.practiceList = []
      this.categoryTwoList = []
      this.pageform.pageNum = 1
      this.show = true
      this.params = {
        page_size: 8,
        page: 1,
      }
      this.getCourseList()
    },
    completeclor: function (index) {
      if (this.count2 === index) {
        return 'adad'
      }
    },
    completeclor1: function (index) {
      if (this.count3 === index) {
        return 'adadss'
      }
    },
    color: function (index) {
      if (this.count === index) {
        return 'activee'
      }
    },
    color2: function (index) {
      if (this.count1 === index) {
        return 'activ'
      }
    },
    training_type(item, index) {
      this.params.category_id = item.value
      // console.log(this.params.category_id)
      if (this.params.learn_name != undefined) {
        this.params.learn_name = ''
      }
      this.count1 = index
      ;(this.count3 = ''), (this.params.page = 1)
      this.pageform.pageNum = 1
      this.getCourseList()
    },
    getCourseList() {
      this.params.state = 'web'
      this.$http
        .courseList(this.params)

        .then((res) => {
          if (res.code !== 0) {
            if (res.data) {
              this.practiceList = res.data.learn
              this.pageform.pages = res.data.allPage
              this.pageform.total = res.data.allCount
              console.log(this.practiceList)
              this.show = false
              this.pageform.total = res.data.allCount
              if (this.pageform.pages == '1' || this.pageform.pages == '0') {
                this.Hidethe_paging = false
              } else {
                this.Hidethe_paging = true
              }
            }

            this.loading = false
          } else {
            this.$message.error(res.message)
          }
          if (this.practiceList == '') {
            this.show = false
          }
        })
    },
  },
  created() {
    this.getCourseList()
    this.getCategoryList()
    this.getTestStatus()

    if (this.$route.params.flag) {
      this.$message.success('个人中心可以完善个人信息哦！')
    }
  },
}
</script>
<style lang="less">
@import '../../../static/fonts/stylemain/style.less';
@media screen and (max-width: 768px) {
  .box-top {
    width: 100vw;
    height: 0.78rem;
    display: flex;
    justify-content: center;
    align-items: center;
    .box-top-inp {
      width: 5rem;
      height: 0.45rem;
      .demo-ruleForm-div {
        background-color: @bg2;
        border: 1px solid @bg1;
        border-radius: 0.225rem;
        height: 0.45rem;
        width: 100%;
        display: flex;
        align-items: center;
        .demo-ruleForm-input {
          background-color: transparent;
          border: 0;
          border-radius: 0.15rem;
          height: 0.45rem;
          width: 100%;
          color: #a7b6c3;
          -webkit-box-sizing: border-box;
          box-sizing: border-box;
          outline: none;
          font-size: 0.16rem;
          border-radius: 0.15rem;
          margin-left: 0.2rem;
        }
        .loginBtn {
          font-family: MicrosoftYaHei;
          color: #ffff;
          width: 2rem;
          outline: none;
          cursor: pointer;
          font-size: 0.2rem;
          box-sizing: border-box;
          -webkit-box-sizing: border-box;
          height: 0.43rem;
          border-radius: 0.4rem;
          background-image: linear-gradient(to right, #00c1ff, #00c1ff);
          border: none;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
    }
  }
  .boxx {
    width: 100%;
    height: 100%;
    background-color: #212129;

    .activee {
      background: #009ad3;
      padding: 10px 10px 10px 10px;
      border-radius: 35px;
    }

    .activ {
      background: #009ad3;
      //  padding: 0 10px 0 10px ;
      //   border-radius: 35px;
    }

    .adad {
      background: #009ad3;
      padding: 0 10px 0 10px;
      border-radius: 35px;
    }

    .adadss {
      background: #009ad3;
      padding: 0 10px 0 10px;
      border-radius: 35px;
    }

    .sousuo {
      height: 78px;
      width: 100%;
      position: relative;

      input {
        width: 60rem;
        height: 35px;
        border: 0;
        border-radius: 25px;
        position: absolute;
        top: 20px;
        left: 20rem;
        outline: none;
      }

      button {
        width: 115px;
        height: 35px;
        background-color: #1eb9ef;
        border: 0;
        border-radius: 25px;
        color: #fff;
        position: absolute;
        top: 21px;
        left: 70rem;
        font-size: 16px;
      }

      img {
        position: absolute;
        top: 30px;
        left: 1085px;
        z-index: 1000;
      }

      .el-icon-close {
        width: 20px;
        height: 20px;
        text-align: center;
        line-height: 20px;
        position: absolute;
        top: 30px;
        left: 60rem;
        color: #595960;
      }
    }

    .options {
      width: 100%;
      // height: 270px;
      background-color: #191a1f;
      overflow: hidden;

      .type {
        width: 100%;
        height: 30rem;
        background-color: #111217;
        margin: 20px auto 0;
        position: relative;
      }

      .direction1 {
        width: 140px;
        height: 34px;
        line-height: 34px;
        margin-left: 35px;
        display: flex;
        justify-content: space-between;
        font-size: 14px;
        color: #fff;
        position: absolute;
        top: 16px;
        left: 0;
      }

      .direction2 {
        width: 140px;
        height: 34px;
        line-height: 34px;
        margin-left: 35px;
        display: flex;
        justify-content: space-between;
        font-size: 14px;
        color: #fff;
        position: absolute;
        top: 16px;
        left: 0px;
      }

      .directionitem {
        line-height: 45rem;
        float: left;
        margin-left: 5rem;
        font-size: 14px;
        color: #fff;

        span {
          margin-left: 16px;
          margin-top: 15px;
        }
      }

      .directionitem1 {
        font-size: 14px;
        color: #fff;
        width: 85%;
        height: 100%;
        margin: 20rem auto 0;
        overflow: hidden;

        span {
          line-height: 10rem;
          display: flex;
          justify-content: space-around;
          height: 35px;
          padding: 2.6rem;
          border-radius: 25px;
        }
      }

      .typebox {
        width: 100%;
        max-height: 320rem;
        background-color: #111217;
        margin: 20px auto;
        position: relative;
        overflow: hidden;

        .xianads {
          display: none;
        }
      }
    }

    .curelist {
      width: 90%;
      height: 100%;
      margin: 2rem auto;
      overflow: hidden;

      .imglist {
        width: 289px;
        height: 200px;
        background-color: #111217;
        margin: 0 auto 6rem;
        position: relative;

        .botomsp {
          height: 41px;
          width: 100%;
          background-color: #111217;
          position: absolute;
          bottom: 0;
          left: 0;
        }

        .sp1 {
          position: absolute;
          top: 131px;
          left: 0;
          color: #ffffff;
          font-size: 12px;
          width: 100%;
          height: 28px;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          display: block;
          line-height: 28px;
          text-align: center;
          background: rgba(0, 0, 0, 0.8);
        }

        .sp2 {
          position: absolute;
          top: 170px;
          left: 22px;
          color: #ffffff;
          z-index: 10000;
        }

        .sp3 {
          position: absolute;
          top: 172px;
          left: 40px;
          color: #ffffff;
          font-size: 12px;
          z-index: 10000;
        }

        .sp4 {
          position: absolute;
          top: 172px;
          left: 118px;
          color: #ffffff;
          z-index: 10000;
        }

        .sp5 {
          position: absolute;
          top: 172px;
          left: 139px;
          color: #ffffff;
          font-size: 12px;
          z-index: 10000;
        }

        .sp6 {
          position: absolute;
          top: 170px;
          left: 189px;
          color: #ffffff;
          z-index: 10000;

          img {
            margin-left: 4px;
          }
        }
      }
    }

    .bottomtion {
      background-color: #2f2f37;
      height: 66px;
      width: 100%;
      position: absolute;
      bottom: -18rem;
      // margin-top: 40px;
      display: flex;
      justify-content: center;
    }

    .el-pagination {
      width: 85%;
      display: flex;
      justify-content: center;
      margin: auto;
    }
  }
}

@media screen and (min-width: 768px) {
  .box-top {
    width: 100vw;
    height: 78px;
    display: flex;
    justify-content: center;
    align-items: center;
    .box-top-inp {
      width: 500px;
      height: 45px;
      .demo-ruleForm-div {
        background-color: @bg2;
        border: 1px solid @bg1;
        border-radius: 22.5px;
        height: 45px;
        width: 100%;
        display: flex;
        align-items: center;
        .demo-ruleForm-input {
          background-color: transparent;
          border: 0;
          border-radius: 15px;
          height: 45px;
          width: 100%;
          color: #a7b6c3;
          -webkit-box-sizing: border-box;
          box-sizing: border-box;
          outline: none;
          font-size: 16px;
          border-radius: 15px;
          margin-left: 20px;
        }
        .loginBtn {
          font-family: MicrosoftYaHei;
          color: #ffff;
          width: 200px;
          outline: none;
          cursor: pointer;
          font-size: 20px;
          box-sizing: border-box;
          -webkit-box-sizing: border-box;
          height: 43px;
          border-radius: 40px;
          background-image: linear-gradient(to right, #00c1ff, #00c1ff);
          border: none;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
    }
  }
  // @bg: var(--bg, #D04A02) ;
  .xianads {
    background-color: @bg2;
  }
  .boxx {
    width: 100%;
    //  height: 910px;
    // min-height: 100vh;
    height: 100%;
    background-color: @bg3;

    .activee {
      background: #009ad3;
      padding: 0 10px 0 10px;
      border-radius: 35px;
      height: 35px;
    }

    .activ {
      background: #009ad3;
      //  padding: 0 10px 0 10px ;
      //   border-radius: 35px;
    }

    .adad {
      background: #009ad3;
      padding: 0 10px 0 10px;
      border-radius: 35px;
    }

    .adadss {
      background: #009ad3;
      padding: 0 10px 0 10px;
      border-radius: 35px;
    }

    .sousuo {
      height: 78px;
      width: 100%;
      position: relative;
      .sousuo-imput {
        background-color: @bg2;
        color: @writing;
        border: 1px solid @bg1;
        padding-left: 20px;
      }
      .kiaguanbis {
        position: absolute;
        right: 350px;
        top: 30px;
      }
      input {
        width: 400px;
        height: 35px;
        border: 0;
        border-radius: 25px;
        position: absolute;
        top: 20px;
        left: 708px;
        outline: none;
      }

      button {
        width: 115px;
        height: 37px;
        background-color: #1eb9ef;
        border: 0;
        border-radius: 25px;
        color: #fff;
        position: absolute;
        top: 20px;
        left: 1060px;
        font-size: 16px;
        padding-left: 30px;
      }

      img {
        position: absolute;
        top: 30px;
        left: 1095px;
        z-index: 1000;
      }

      .el-icon-close {
        width: 20px;
        height: 20px;
        text-align: center;
        line-height: 20px;
        position: absolute;
        top: 30px;
        left: 1035px;
        color: #595960;
      }
    }

    .options {
      width: 100%;
      background-color: @bg2;
      overflow: hidden;

      .type {
        width: 1216px;
        height: 68px;
        background-color: @bg1;
        position: relative;
        margin: 20px auto 0px;
      }

      .direction1 {
        width: 140px;
        height: 34px;
        line-height: 34px;
        margin-left: 35px;
        display: flex;
        justify-content: space-between;
        font-size: 14px;
        color: @writing;
        position: absolute;
        top: 16px;
        left: 0;
      }

      .direction2 {
        width: 140px;
        height: 34px;
        line-height: 34px;
        margin-left: 35px;
        display: flex;
        justify-content: space-between;
        font-size: 14px;
        color: @writing;
        position: absolute;
        top: 16px;
        left: 0px;
      }

      .directionitem {
        line-height: 35px;
        margin-left: 184px;
        font-size: 14px;
        color: @writing;

        span {
          margin-left: 16px;
          float: left;
          margin-top: 15px;
        }
      }

      .directionitem1 {
        margin-left: 160px;
        font-size: 14px;
        color: @writing;
        width: 891px;
        height: 100%;
        overflow: hidden;

        span {
          margin-top: 15px;
          margin-bottom: 17px;
          margin-left: 39px;
          float: left;
          height: 35px;
          line-height: 35px;
          padding: 0 10px 0 10px;
          border-radius: 25px;
        }
      }

      .typebox {
        width: 1216px;
        max-height: 130px;
        background-color: @bg1;
        margin: 0 auto 20px;
        position: relative;
        overflow: hidden;
      }

      .xiabin {
        width: 1216px;
        max-height: 130px;
        background-color: #1431c4;
        margin: auto;
        position: relative;
        overflow: hidden;
        margin-bottom: 20px;
      }
    }

    .curelist {
      width: 1250px;
      height: 434px;
      margin: 20px auto;
      padding-right: 10px;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      overflow: hidden;

      .imglist {
        width: 289px;
        height: 200px;
        background-color: @bg1;
        margin-bottom: 34px;
        position: relative;
        margin-left: 21px;
        z-index: 99;
        .botomsp {
          height: 41px;
          width: 100%;
          background-color: @bg1;
          position: absolute;
          bottom: 0;
          left: 0;
        }

        .sp1 {
          position: absolute;
          top: 131px;
          left: 0;
          color: #ffffff;
          font-size: 12px;
          width: 100%;
          height: 28px;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          display: block;
          line-height: 28px;
          text-align: center;
          background: rgba(0, 0, 0, 0.8);
        }

        .sp2 {
          position: absolute;
          top: 170px;
          left: 22px;
          color: #ffffff;
          z-index: 10000;
        }

        .sp3 {
          position: absolute;
          top: 172px;
          left: 40px;
          color: #ffffff;
          font-size: 12px;
          z-index: 10000;
        }

        .sp4 {
          position: absolute;
          top: 172px;
          left: 118px;
          color: #ffffff;
          z-index: 10000;
        }

        .sp5 {
          position: absolute;
          top: 172px;
          left: 139px;
          color: #ffffff;
          font-size: 12px;
          z-index: 10000;
        }

        .sp6 {
          position: absolute;
          top: 170px;
          left: 189px;
          color: #ffffff;
          z-index: 10000;

          img {
            margin-left: 4px;
          }
        }
      }
    }

    .bottomtion {
      background-color: @bottomtion;
      height: 66px;
      width: 100%;
      // position: absolute;
      // bottom: -20px;
      // margin-top: 40px;
      display: flex;
      justify-content: center;
    }

    .el-pagination {
      margin: auto;
    }
  }
  .boxxs1 {
    width: 100%;
    //  height: 910px;
    // min-height: 100vh;
    height: 100%;
    background-color: rgb(5, 34, 39);

    .activee {
      background: #009ad3;
      padding: 0 10px 0 10px;
      border-radius: 35px;
      height: 35px;
    }

    .activ {
      background: #009ad3;
      //  padding: 0 10px 0 10px ;
      //   border-radius: 35px;
    }

    .adad {
      background: #009ad3;
      padding: 0 10px 0 10px;
      border-radius: 35px;
    }

    .adadss {
      background: #009ad3;
      padding: 0 10px 0 10px;
      border-radius: 35px;
    }

    .sousuo {
      height: 78px;
      width: 100%;
      position: relative;
      .kiaguanbis {
        position: absolute;
        right: 350px;
        top: 30px;
      }
      input {
        width: 400px;
        height: 35px;
        border: 0;
        border-radius: 25px;
        position: absolute;
        top: 20px;
        left: 708px;
        outline: none;
      }

      button {
        width: 115px;
        height: 35px;
        background-color: #1eb9ef;
        border: 0;
        border-radius: 25px;
        color: #fff;
        position: absolute;
        top: 21px;
        left: 1060px;
        font-size: 16px;
        padding-left: 30px;
      }

      img {
        position: absolute;
        top: 30px;
        left: 1085px;
        z-index: 1000;
      }

      .el-icon-close {
        width: 20px;
        height: 20px;
        text-align: center;
        line-height: 20px;
        position: absolute;
        top: 30px;
        left: 1035px;
        color: #595960;
      }
    }

    .options {
      width: 100%;
      background-color: #191a1f;
      overflow: hidden;

      .type {
        width: 1216px;
        height: 68px;
        background-color: #111217;
        position: relative;
        margin: 40px auto 20px;
      }

      .direction1 {
        width: 140px;
        height: 34px;
        line-height: 34px;
        margin-left: 35px;
        display: flex;
        justify-content: space-between;
        font-size: 14px;
        color: #fff;
        position: absolute;
        top: 16px;
        left: 0;
      }

      .direction2 {
        width: 140px;
        height: 34px;
        line-height: 34px;
        margin-left: 35px;
        display: flex;
        justify-content: space-between;
        font-size: 14px;
        color: @writing;
        position: absolute;
        top: 16px;
        left: 0px;
      }

      .directionitem {
        line-height: 35px;
        margin-left: 184px;
        font-size: 14px;
        color: #fff;

        span {
          margin-left: 16px;
          float: left;
          margin-top: 15px;
        }
      }

      .directionitem1 {
        margin-left: 160px;
        font-size: 14px;
        color: #fff;
        width: 891px;
        height: 100%;
        overflow: hidden;

        span {
          margin-top: 15px;
          margin-bottom: 17px;
          margin-left: 39px;
          float: left;
          height: 35px;
          line-height: 35px;
          padding: 0 10px 0 10px;
          border-radius: 25px;
        }
      }

      .typebox {
        width: 1216px;
        max-height: 130px;
        background-color: #111217;
        margin: 0 auto 20px;
        position: relative;
        overflow: hidden;
      }

      .xiabin {
        width: 1216px;
        max-height: 130px;
        background-color: #1431c4;
        margin: auto;
        position: relative;
        overflow: hidden;
        margin-bottom: 20px;
      }
    }
    .optionss1a {
      width: 100%;
      background-color: rgb(11, 51, 51);
      overflow: hidden;

      .type {
        width: 1216px;
        height: 68px;
        background-color: #111217;
        position: relative;
        margin: 40px auto 20px;
      }

      .direction1 {
        width: 140px;
        height: 34px;
        line-height: 34px;
        margin-left: 35px;
        display: flex;
        justify-content: space-between;
        font-size: 14px;
        color: #fff;
        position: absolute;
        top: 16px;
        left: 0;
      }

      .direction2 {
        width: 140px;
        height: 34px;
        line-height: 34px;
        margin-left: 35px;
        display: flex;
        justify-content: space-between;
        font-size: 14px;
        color: @writing;
        position: absolute;
        top: 16px;
        left: 0px;
      }

      .directionitem {
        line-height: 35px;
        margin-left: 184px;
        font-size: 14px;
        color: #fff;

        span {
          margin-left: 16px;
          float: left;
          margin-top: 15px;
        }
      }

      .directionitem1 {
        margin-left: 160px;
        font-size: 14px;
        color: #fff;
        width: 891px;
        height: 100%;
        overflow: hidden;

        span {
          margin-top: 15px;
          margin-bottom: 17px;
          margin-left: 39px;
          float: left;
          height: 35px;
          line-height: 35px;
          padding: 0 10px 0 10px;
          border-radius: 25px;
        }
      }

      .typebox {
        width: 1216px;
        max-height: 130px;
        background-color: #111217;
        margin: 0 auto 20px;
        position: relative;
        overflow: hidden;
      }

      .xiabin {
        width: 1216px;
        max-height: 130px;
        background-color: #1431c4;
        margin: auto;
        position: relative;
        overflow: hidden;
        margin-bottom: 20px;
      }
    }
    .curelist {
      width: 1250px;
      height: 434px;
      margin: 20px auto;
      padding-right: 10px;
      display: flex;
      flex-direction: row;
      flex-wrap: wrap;
      overflow: hidden;

      .imglist {
        width: 289px;
        height: 200px;
        background-color: #111217;
        margin-bottom: 34px;
        position: relative;
        margin-left: 21px;

        .botomsp {
          height: 41px;
          width: 100%;
          background-color: #111217;
          position: absolute;
          bottom: 0;
          left: 0;
        }

        .sp1 {
          position: absolute;
          top: 131px;
          left: 0;
          color: #ffffff;
          font-size: 12px;
          width: 100%;
          height: 28px;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          display: block;
          line-height: 28px;
          text-align: center;
          background: rgba(0, 0, 0, 0.8);
        }

        .sp2 {
          position: absolute;
          top: 170px;
          left: 22px;
          color: #ffffff;
          z-index: 10000;
        }

        .sp3 {
          position: absolute;
          top: 172px;
          left: 40px;
          color: #ffffff;
          font-size: 12px;
          z-index: 10000;
        }

        .sp4 {
          position: absolute;
          top: 172px;
          left: 118px;
          color: #ffffff;
          z-index: 10000;
        }

        .sp5 {
          position: absolute;
          top: 172px;
          left: 139px;
          color: #ffffff;
          font-size: 12px;
          z-index: 10000;
        }

        .sp6 {
          position: absolute;
          top: 170px;
          left: 189px;
          color: #ffffff;
          z-index: 10000;

          img {
            margin-left: 4px;
          }
        }
      }
    }

    .bottomtion {
      background-color: #2f2f37;
      height: 66px;
      width: 100%;
      // position: absolute;
      // bottom: -20px;
      // margin-top: 40px;
      display: flex;
      justify-content: center;
    }

    .el-pagination {
      margin: auto;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/User/PracticeList.vue